import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbExamplerComponent } from './sb-exampler.component';
import { SbCodeModule } from '../code/sb-code.module';
import { SbCardModule } from './sb-card/sb-card.module';
import { SbIconsModule } from './sb-icons/sb-icons.module';

const COMPONENTS = [
  SbExamplerComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,

    SbCodeModule,
    SbCardModule,
    SbIconsModule,
  ],
})
export class SbExamplerModule { }
